import { useUser } from "../lib/user";
import * as React from "react";

export default function Logout() {
  const { logout } = useUser();

  React.useEffect(() => {
    logout();

    window.location.href = "/login";
  }, [logout]);

  return null;
}
